import OrderEntry from "./OrderEntry/OrderEntry";

export const TRANSACTION_TYPE = {
  'all': "All",
  'invoice': "Invoice",
  'unappliedcash': "Unapplied Cash",
  'unapplied': "Unapplied Cash",
  'debitnote': "Debit Note",
  'creditnote': "Credit Note",
  'interest': "Interest",
  'prepayment': "Prepayment",
  'receipt': "Receipt",
  'refund': "Refund",
  'active': "Active",
  'future': "Future",
  'standing': "Standing",
  'quote': "Quote",
  'order': "Order",
}

export const REGISTRATION_FIELD = {
    "zipCode":'Zip Code',
    "email":'Email',
    "lastPaymentAmount": 'Last Payment Amount',
    "lastInvoiceNumber": 'Last Invoice Number',
    "lastInvoiceAmount":'Last Invoice Amount'
}

export const GRAPH_DATASET_OPT = {
  barPercentage: 0.5,
  borderWidth:1,
  fontFamily:'open_sansregular, Arial',
  hoverBackgroundColor:'#0066ff',
  hoverBorderColor:'#0066ff',
  backgroundColor: [ 'rgba(58,118,126, 1)', 'rgba(56,161,172,1)', 'rgba(52,201,209,1)' ],
  borderColor: [ 'rgba(58,118,126, 1)', 'rgba(56,161,172,1)', 'rgba(52,201,209,1)' ]
}

export const GRAPH_OPTION = {
    plugins: {
        datalabels: {
            display: true,
            align: 'end',
            anchor: 'end',
            offset: 2,
            formatter: ((value, context) => { return document.getElementById('currencysymbol').value + value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') })
        }
    },
    responsive: true,
    hoverMode: 'label',
    stacked: false,
    legend: { display: false },
    scales: {
        xAxes: [{
            gridLines: { show: false, drawOnChartArea: false, offsetGridLines: true },
            scaleLabel: { display: true, labelString: "", fontSize: 18, fontFamily: 'open_sansregular, Arial' }
        }],
        yAxes: [{
            type: 'linear',
            display: true,
            position: 'left',
            integersOnly: true,
            override: null,
            gridLines: { show: true },
            scaleLabel: { display: true, fontSize: 18, fontFamily: 'open_sansregular, Arial' },
            labels: { template: "", fontFamily: 'open_sansregular, Arial' },
            ticks: { beginAtZero: true }
        }]
    }
};

export const N49LOGO = "/content/0/N49logo.svg";

export const FEATURES_ROUTE_MAPPING = {
    AccountActivity: { pathName: 'activity', img: '/content/0/accountactivity.jpg'},
    ViewTransactions: { pathName: "transactions", img: '/content/0/viewtransactions.jpg'},
    ClickToPay: { pathName: "quickpay", img: 'abc'},
    ViewOrders: { pathName: "orders", img: '/content/0/vieworders.jpg'},
    StoredCards: { pathName: "manageCredt", img: '/content/0/managecredit.jpg'},
    PayAccount: { pathName: "payment", img: '/content/0/payaccount.jpg' },
    Prepayment: { pathName: "prepayment", img: '/content/0/payaccount.jpg' },
    ContactUs: { pathName: "contactus", img: '/content/0/contactus.jpg' },
    OrderEntry: { pathName: "orderentry", img: '/content/0/orderentry.jpg' },
  // password   : 'content/0/changepassword.jpg',
};

export const CARD_IMG_LIST = {
    'visa': { name: 'Visa', icon:'/content/0/visa_logo.png'},
    'mastercard': { name: 'Mastercard', icon:'/content/0/mastercard_logo.png'},
    'americanexpress': { name: 'American Express', icon:'/content/0/AXP_BlueBoxLogo_EXTRALARGEscale_RGB_DIGITAL_1600x1600.png'},
    'discover': { name: 'Discover', icon:'/content/0/discover_logo.png'},
    //'paypal': { name: 'PayPal', icon:'/content/0/CC_AMEX.jpg'}
    'check': { name: 'Check', icon: '/content/0/check.png' },
    'ach': { name: 'ACH', icon: '/content/0/check.png' },
    'undefined': { name: 'undefined', icon: '' }
}
